import Common from '../Common/Constants'

export default {
    name: 'ClubCount',
    components: {},
    data() {
        return {
            constant: Common,
            loader: false,
            header: {},
            allClubsData: [],
            clubData: [],
            talukaData: [],
            officerCountData: [],
            searchTask: '',
            serachFlag: false,
            user: {},
        }
    },
    created: function () {
        let self = this;
        let token = localStorage.getItem('token');
        self.user = JSON.parse(localStorage.getItem('user'));
        /*if (token === '' || token === undefined || token === null) {
            self.$router.push('/')
        }*/
        self.header = {
            "Content-Type": "application/json",
            "token": token,
        };
        self.getClubInfo();
        self.getRegisteredOfficerCountDetails();
    },
    computed:
        {
            filteredClubs: function () {
                let self = this;
                // let result = this.talukaData
                let result = this.talukaData.filter(function (task) {
                    task.name = task.name === null ? '' : task.name;
                    return task.name.toLowerCase().indexOf(self.searchTask.toLowerCase()) >= 0;
                });
                if (result.length == 0) {
                    return this.serachFlag = true
                }
                else {
                    this.serachFlag = false;
                    return result;
                }

            }
        },
    methods: {

        getClubInfo() {
            let self = this;
            self.loader = true;
            axios.get(self.constant.apiUrl + "club/clubInfo")
                .then(function (response) {
                    if (response.data.flag) {
                        self.allClubsData = response.data.data;
                        self.clubData = self.allClubsData.clubTypeCount;
                        self.talukaData = self.allClubsData.talukaCount;
                        self.loader = false;
                    }
                    else {
                        console.log(response.data.message)
                    }
                })

        },
        getRegisteredOfficerCountDetails() {
            let self = this;
            self.loader = true;
            axios.get(self.constant.apiUrl + "countDetails")
                .then(function (response) {
                    if (response.data.flag) {
                        self.officerCountData = response.data.data;
                    }
                    else {
                        console.log(response.data.message)
                    }
                })

        },
        filterMember(data) {
            let self = this;
            let elc_type = '';
            self.constant.elc_type.forEach(function (val) {
                if (val.value == data) {
                    elc_type = val.id
                }
            });
            self.$router.push('/clubs/' + elc_type + '/taluka/club');

        }, filterMemberTaluka(data, value) {
            let self = this;
            let elc_type = '';
            self.constant.elc_type.forEach(function (val) {
                if (val.value == value.type) {
                    elc_type = val.id
                }
            });
            self.$router.push('/clubs/district/' + data + '/' + elc_type);

        },
        filterMemberTalukaName(data) {
            let self = this;
            self.$router.push('/clubs/district/' + data.name + '/club');
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/ClubCount/ClubCount.js